import { render, staticRenderFns } from "./shopBuyerAuthSet.vue?vue&type=template&id=e3d05e36&"
import script from "./shopBuyerAuthSet.vue?vue&type=script&lang=js&"
export * from "./shopBuyerAuthSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports